module.exports = __webpack_public_path__ + "static/media/night.8a8ff120.svg";